import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Col, Button,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ButtonsContainer } from './styles';
import ModalKonfirmasi from '../../../../components/ModalKonfirmasi';

const Buttons = ({ onSubmit }) => {
  const [modalShow, setModalShow] = useState(false);

  const handleSubmit = () => {
    onSubmit();
    setModalShow(false);
  };

  return (

    <ButtonsContainer>
      <Col className="col-12 text-right buttonKanan">
        <Link to="/">
          <Button className="btnCancel btn-primary mr-2" variant="danger">Kembali</Button>
        </Link>
        <Button className="btnKirim btn-primary" variant="success" onClick={() => setModalShow(true)}>Ubah</Button>
      </Col>
      <ModalKonfirmasi
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSubmit={handleSubmit}
      />
    </ButtonsContainer>
  );
};

Buttons.defaultProps = {
  onSubmit: () => 'Do Nothing',
};

Buttons.propTypes = {
  onSubmit: PropTypes.func,
};

export default Buttons;
